import React from 'react';
import { Form } from 'react-final-form';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import { API_PATHS } from 'api';
import { Button, EmailField, PasswordField } from 'components';
import { APP_URI } from 'config';
import { useAuth, useTanstackMutation } from 'hooks';
import { AuthBody } from 'models';
import { AuthContainer } from 'pages/components';

import './Login.styles.scss';

interface LoginFormValues {
  email: string;
  password: string;
}

const Login: React.FC = () => {
  const { setCredentials } = useAuth();
  const navigate = useNavigate();

  const { mutate: mutateLogin, isPending: isPendingLogin } =
    useTanstackMutation<AuthBody, LoginFormValues>({
      onSuccess: (data) => {
        setCredentials(data);
        navigate(APP_URI.CAMPAIGNS);
      },
      onError: (error) => {
        console.error(error);
        toast.error('Login failed. Please try again.');
      },
    });

  return (
    <Form<LoginFormValues>
      onSubmit={(data) => {
        mutateLogin({
          path: API_PATHS.auth.login(),
          method: 'post',
          body: data,
        });
      }}
      render={({ handleSubmit }) => (
        <AuthContainer title="Login">
          <form onSubmit={handleSubmit} className="login-form">
            <EmailField />
            <PasswordField />

            <Link
              className="login-form__forgot-password"
              to={APP_URI.FORGOT_PASSWORD}
            >
              Forgot password?
            </Link>

            <Button
              type="submit"
              className="submit-button"
              isLoading={isPendingLogin}
            >
              Login
            </Button>
          </form>
        </AuthContainer>
      )}
    />
  );
};

export default Login;
